<template>
  <div class="page-auth">
    <div class="w-100 h-100 overflow-auto">
      <div class="row m-0">
        <div class="col-10 col-sm-8 col-md-6 col-lg-4 mx-auto login-form">
          <div class="login-form-header bg-dashboard-dark-1 p-2">
            <img src="@/assets/jkr-logo.png" />
            <p class="mb-0 mr-2 font-weight-bold text-white">LOGIN</p>
          </div>
          <div class="login-form-body bg-dashboard-dark-1">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <div
                  class="input-group-text rounded-0 bg-white border-right-0 text-muted pr-1 border-outline-dark bg-dark-input"
                  :class="{ 'border-danger': errors.identifier }"
                >
                  <font-awesome-icon :icon="['fas', 'at']" />
                </div>
              </div>
              <input
                type="text"
                class="form-control border-left-0 bg-dark-input border-outline-dark text-white"
                :class="{ 'border-danger': errors.identifier }"
                placeholder="Email"
                @keydown.enter="login()"
                v-model="models.identifier"
              />
            </div>
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                <div
                  class="input-group-text rounded-0 bg-white border-right-0 text-muted pr-1 bg-dark-input border-outline-dark"
                  :class="{ 'border-danger': errors.password }"
                >
                  <font-awesome-icon :icon="['fas', 'lock-open']" />
                </div>
              </div>
              <input
                type="password"
                class="form-control border-left-0 bg-dark-input border-outline-dark text-white"
                :class="{ 'border-danger': errors.password }"
                placeholder="Password"
                @keydown.enter="login()"
                v-model="models.password"
              />
            </div>
            <p class="small text-danger text-center" v-if="loginError">
              Invalid email/password
            </p>
            <button
              class="btn btn-block btn-login btn-primary rounded-0"
              @click="login()"
              :disabled="isProcessing"
            >
              <span>Login</span>
              <div
                class="spinner-border spinner-border-sm text-light"
                v-if="isProcessing"
              ></div>
            </button>
            <button
              type="button"
              class="btn btn-link w-100 mt-3"
              @click="goTo('Forget')"
            >
              Forgot your password?
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import Swal from "sweetalert2";

export default {
  name: "auth",
  data() {
    return {
      isProcessing: false,
      loginError: false,
      models: {
        identifier: "",
        password: "",
      },
      errors: {
        identifier: false,
        password: false,
      },
    };
  },
  methods: {
    login() {
      this.isProcessing = true;
      const hasError = this.verifyForm();
      if (!hasError) {
        API.post("auth/local", this.models)
          .then((retVal) => {
            delete retVal.data.user.cases;
            delete retVal.data.user.comments;

            localStorage.setItem("user", JSON.stringify(retVal.data.user));
            localStorage.setItem("token", retVal.data.jwt);

            this.$nextTick(() => {
              const redirect = this.$route.query.redirect;
              this.$router.push(
                redirect && redirect.startsWith("/")
                  ? redirect
                  : { name: "landing" }
              );
            });

            this.isProcessing = false;
          })
          .catch((err) => {
            console.error(err);

            this.isProcessing = false;

            const errId =
              err?.response?.data?.message?.[0]?.messages?.[0]?.id;
            let message;
            if (errId === "Auth.form.error.blocked") {
              message = "Your account has been blocked by an administrator.";
            } else if (errId === "Auth.form.error.invalid") {
              message = "Invalid email or password.";
            } else {
              message =
                "Something went wrong. Please try again or contact the administrator.";
            }

            Swal.fire("Login failed", message, "error");
          });
      } else {
        this.isProcessing = false;
      }
    },
    verifyForm() {
      this.loginError = false;
      for (let index = 0; index < Object.keys(this.models).length; index++) {
        const key = Object.keys(this.models)[index];
        const model = this.models[key];

        if (!model) {
          this.errors[key] = true;
          this.loginError = true;
        } else {
          this.errors[key] = false;
        }
      }
      return this.loginError;
    },
    goTo(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>
